
import { CheckCircle2, Star, Trash2, X } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DocumentProps } from "@/hooks/admin/identity-docs/useSubmittedDocuments";

interface DocumentActionsDropdownProps {
  document: DocumentProps;
  canSetPrimary?: boolean;
  dropdownOpen: boolean;
  onDropdownOpenChange: (open: boolean) => void;
  onApprovalDialog: () => void;
  onRejectDialog: () => void;
  onDeleteDialog: () => void;
  onSetPrimaryDialog: () => void;
}

export function DocumentActionsDropdown({
  document,
  canSetPrimary,
  dropdownOpen,
  onDropdownOpenChange,
  onApprovalDialog,
  onRejectDialog,
  onDeleteDialog,
  onSetPrimaryDialog
}: DocumentActionsDropdownProps) {
  const showSetPrimaryOption = canSetPrimary && 
    document.verification_status === 'verified' && 
    !document.primary_document;

  return (
    <DropdownMenu open={dropdownOpen} onOpenChange={(open) => {
      console.log('Dropdown state changing:', { from: dropdownOpen, to: open, documentId: document.id });
      onDropdownOpenChange(open);
    }}>
      <DropdownMenuTrigger asChild>
        <div 
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-8 w-8 cursor-pointer"
          role="button"
          tabIndex={0}
        >
          <span className="sr-only">Open menu</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {document.verification_status === "pending" && (
          <>
            <DropdownMenuItem 
              onClick={onApprovalDialog}
              className="text-green-600"
            >
              <CheckCircle2 className="mr-2 h-4 w-4" />
              <span>Approve</span>
            </DropdownMenuItem>
            
            <DropdownMenuItem 
              onClick={onRejectDialog}
              className="text-destructive"
            >
              <X className="mr-2 h-4 w-4" />
              <span>Reject</span>
            </DropdownMenuItem>
          </>
        )}
        
        {showSetPrimaryOption && (
          <DropdownMenuItem onClick={onSetPrimaryDialog}>
            <Star className="mr-2 h-4 w-4" />
            <span>Set as Primary</span>
          </DropdownMenuItem>
        )}
        
        <DropdownMenuItem 
          onClick={onDeleteDialog}
          className="text-destructive"
        >
          <Trash2 className="mr-2 h-4 w-4" />
          <span>Delete Document</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
